/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../bank-accounts/bank_accounts';
import '../../models/external_bank_account';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "LinkExternalBankAccountRequest": {
                    "fields": {
                      "idempotencyKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "accountType": {
                        "type": ".squareup.bank_accounts.BankAccountType",
                        "id": 3,
                        "rule": "optional"
                      },
                      "primaryBankIdentificationNumber": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "accountNumber": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "LinkExternalBankAccountResponse": {
                    "fields": {
                      "externalBankAccount": {
                        "type": ".squareup.sfs.external.models.ExternalBankAccount",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.LinkExternalBankAccountRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.LinkExternalBankAccountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE LinkExternalBankAccountRequest @ squareup/sfs/external/services/external_bank_account/link_external_bank_account.proto at 12:1
 */
export const LinkExternalBankAccountRequest = $root.lookupType('squareup.sfs.external.service.LinkExternalBankAccountRequest');
fixType(LinkExternalBankAccountRequest, {
  idempotencyKey: {
    notEmpty: true
  },
  customerId: {
    required: true
  },
  accountType: {
    required: true
  },
  primaryBankIdentificationNumber: {
    required: true
  },
  accountNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LinkExternalBankAccountRequest);
/**
 * SOURCE LinkExternalBankAccountResponse @ squareup/sfs/external/services/external_bank_account/link_external_bank_account.proto at 47:1
 */
export const LinkExternalBankAccountResponse = $root.lookupType('squareup.sfs.external.service.LinkExternalBankAccountResponse');
fixType(LinkExternalBankAccountResponse);
Builder.createAndAttachToType(LinkExternalBankAccountResponse);